export default {
  metaTitle: 'Store Account',
  pageTitle: 'Manage Staff Accounts',
  secendTitle: 'Store Account List',
  newStaff: 'New Staff',
  staff: 'Staff',
  staffId: 'Staff ID',
  loginAccount: 'Login Account',
  trueName: 'True Name',
  password: 'Password',
  status: 'Status',
  active: 'Active',
  locked: 'Locked',
  save: 'Save',
  title1: 'Permission Configuration',
  accountInfo: 'Account Info',
  staffInfo1: 'hello',
  staffInfo2: 'ven',
  moduleList1: 'Product',
  moduleList2: 'Orders',
  moduleList3: 'Store',
  moduleList4: 'Coupon',
  moduleList5: 'Flash Sales',
  moduleList6: 'Customer',
  moduleList7: 'Operation',
  moduleList8: 'After Sales',
  moduleList9: 'Settlement',
  moduleList10: 'Promotions',
  // -------------
  name2: 'Warehouse settings',
  name3: 'Add Product',
  name4: 'Product list',
  name5: 'Store Category Settings',
  name6: 'Batch import product',
  name7: 'Product Reviews',
  name8: 'Set extended prices in bulk',
  name9: 'Sales Order',
  name10: 'Dispatch Order',
  name11: 'Drop Shipping Setting',
  name12: 'Store List',
  name13: 'Store Settings',
  name15: 'Store Account Management',
  name16: 'Developer Information',
  name17: 'Voucher Type',
  name18: 'Voucher batch management',
  name19: 'Voucher management',
  name20: 'Flash-Sale Products',
  name21: 'Flashsale Applied',
  name22: 'Apply for TD',
  name23: "My Today's Deal",
  name24: 'Talking Messages',
  name25: 'Coins Plan',
  name26: 'Recommended Product Settings',
  name27: 'Apply for Promotion',
  name28: 'After Sale',
  name29: 'Settlement',
  name30: 'Attend promotion(All types)',
  name31: 'My Group-on',
  name32: '我参与的大促',
  // ----------------
  add: 'Add',
  edit: 'Edit',
  column1: 'Staff ID',
  column2: 'Account(login)',
  column3: 'True Name',
  column4: 'Status',
  column5: 'Operation',
  column6: 'Last Login IP',
  column7: 'Last Login Time',
  // active: 'active',
  // locked: 'locked',
  permission: 'Permission',
  warning1: 'Please enter Username.',
  warning2: 'Please enter Truename.',
  warning3: 'Please enter Password.',
  warning4: 'Password length cannot be less than 6.',
  warning5: 'Password Choose status',
  marketScope: 'Market Scope',
  warning6: 'Please select at least one market.'
}
